import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";

import CreateCampaignPreviewPage from "components/campaignStreamline/CreateCampaignPreviewPage";
import { MESSAGE_TAB } from "./MessageList";
import BaseForm from "components/base/v2/BaseForm";
import { generalMessageCampaignSessionDataKey, removeDataFromSessionStorage, saveDataToSessionStorage } from "models/CreateCampaignModel";
import { ActionType, APIStatus, CampaignType } from "config/CustomEnums";
import CustomBreadcrumb from "components/base/CustomBreadcrumb";
import { createMessageCampaignBreads } from "config/CustomBreadConfig";
import { PermissionCodes } from "config/PermissionCodes";
import { getCampaignCreateSuccessStepBar, getCampaignStepBarNameWithType } from "components/base/prompt/NextStepConfig";
import { createAction } from "utils";
import { stepNamesConfig } from "models/CampaignStreamlineModel";
import CreateMessageCampaignContentPage from "components/message/CreateMessageCampaignContentPage";
import { CREATE_MESSAGE_CAMPAIGN_PREVIEW_PAGE_CONFIG } from "./CreateMessageCampaignPerviewPageConfig";
import Loading from "components/base/Loading";


const mapStateToProps = (state) => ({
  stepConfig: state.campaignStreamline.stepConfig,
  currentStep: state.campaignStreamline.currentStep,
  campaign: state.createCampaign.campaign,
  campaignPublish: state.createCampaign.campaignPublish,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
  hasUpdatedDefaultValues: state.createCampaign.hasUpdatedDefaultValues,
  detailLoading: state.createCampaign.detailLoading,
});

const CreateMessageCampaign = ({
  stepConfig,
  currentStep,
  campaign = {},
  campaignPublish,
  formHasSubmitted,
  hasUpdatedDefaultValues,
  detailLoading,
}) => {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const campaignType = campaign.campaignType;
  const campaignId = campaign.pk;
  const campaignGeneralName = campaign.translations?.en?.generalName;

  const saveDraftAction = (formContext) => {
    const { getValues } = formContext;
    dispatch({
      type: 'createCampaign/createOrUpdateCampaignV2',
      payload: {
        data: getValues(),
        actionType: ActionType.save,
        resume: location.state?.resume,
      }
    });
  };

  useEffect(() => {
    dispatch({ type: 'createCampaign/clearData' });
    dispatch({ type: 'campaignStreamline/clearData' })
    dispatch(createAction("campaignStreamline/updateSteps")({
      customNameList: stepNamesConfig.messgaeCampaign,
      hideFirstStep: false,
    }))
    if (!history.location.search) {
      const campaignId = params.id;
      if (campaignId) {
        dispatch({ type: 'createCampaign/getOneCampaign', payload: { id: campaignId } });
      } else {
        dispatch({
          type: 'createCampaign/loadCampaignFromCookie',
          payload: {
            resume: location.state?.resume,
            campaignType: CampaignType.generalMessageCampaign,
          }
        });
      }
      dispatch({ type: 'brand/getCurrentPageBrands', payload: {} });
    }
    dispatch({ type: 'language/getList', payload: { isSelectorLoad: true } });
    dispatch({ type: 'settings/getAdminTipConfig' });
    return () => {
      dispatch({ type: 'createCampaign/clearData' });
      dispatch({ type: 'campaignStreamline/clearData' })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const stepSet = [
    <CreateMessageCampaignContentPage saveDraftAction={saveDraftAction}/>,
    <CreateCampaignPreviewPage
      previewPageConfig={CREATE_MESSAGE_CAMPAIGN_PREVIEW_PAGE_CONFIG}
      listpath="/messages"
      isMessageCampaign
    />,
  ]


  const toCampaignList = () => {
    history.push({
      pathname: '/messgaes',
      hash: MESSAGE_TAB.MESSAGE_CAMPAIGN,
    });
  };

  const getCompleteSteps = () => {
    return getCampaignCreateSuccessStepBar(CampaignType.generalMessageCampaign);
  };
  if (detailLoading === APIStatus.calling) {
    return <Loading />
  }


  if (detailLoading === APIStatus.calling) {
    return <Loading />
  };

  return (
    <BaseForm
      useStepsV2
      stepOnClick={(step) => {
        dispatch({ type: 'campaignStreamline/stepChange', payload: { step: step } })
      }}
      defaultValues={campaign}
      formHasSubmitted={formHasSubmitted}
      hasUpdatedDefaultValues={hasUpdatedDefaultValues}
      tempSave={(save, getValues) => {
        if (save) {
          saveDataToSessionStorage(getValues(), false, CampaignType.generalMessageCampaign);
        } else {
          removeDataFromSessionStorage(false, CampaignType.generalMessageCampaign);
        }
      }}
      showFinishPop={campaignPublish === APIStatus.success}
      nextStepConfig={{
        title: 'Successfully Published!',
        description:
          'The campaign is successfully published.\n Let your customers know about the campaign.',
        steps: {
          stepNames: getCompleteSteps(),
          current: getCampaignStepBarNameWithType(campaignType),
        },
        onHide: () => { },
        buttons: [
          {
            text: 'Create message',
            action: () => {
              history.push({
                pathname: '/messages/create',
                search: `${location.search}&campaign=${campaignId}${location.search ? '' : '&type=' + campaignType
                  }`,
              });
            },
            requires: PermissionCodes.addMessage,
          },
          {
            text: 'Maybe Later',
            action: toCampaignList,
          },
        ],
      }}
      continueCreateConfig={{
        onConfirm: () => {
          history.push(history.location.state?.from);
        },
        onCancel: toCampaignList,
        onClose: toCampaignList,
      }}
      sessionDataKey={generalMessageCampaignSessionDataKey}
      content={stepSet}
      currentStep={currentStep}
      breadcrumb={
        <CustomBreadcrumb
          breadcrumbs={createMessageCampaignBreads(
            campaignId ? campaignGeneralName : 'Create Messgae Campaign',
          )}
        />
      }
      stepsConfig={stepConfig}
      caution={{
        detail: '',
        title: campaignId ? campaignGeneralName : 'Create Messgae Campaign',
      }}
      hasleavePagePrompt={params.id}
    />
  );
}


export default connect(mapStateToProps)(CreateMessageCampaign);